export const OPERATION_LOG_PAGE_SIZE = 20;

export const EMPTY_OPERATION_LOG_FILTERS = {
  adminName: '',
  operation: '',
  startTimeInput: '',
  endTimeInput: '',
};

export function fromDateTimeInput(value) {
  if (!value) {
    return '';
  }
  if (value.includes('T')) {
    const [date, time] = value.split('T');
    const hhmm = time.length === 5 ? `${time}:00` : time;
    return `${date} ${hhmm}`;
  }
  return value;
}

export function buildOperationLogPageParams(pageNo, filters, pageSize = OPERATION_LOG_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.adminName?.trim()) {
    params.adminName = filters.adminName.trim();
  }
  if (filters.operation?.trim()) {
    params.operation = filters.operation.trim();
  }
  const start = fromDateTimeInput(filters.startTimeInput);
  const end = fromDateTimeInput(filters.endTimeInput);
  if (start) {
    params.startTime = start;
  }
  if (end) {
    params.endTime = end;
  }
  return params;
}
